(() => {
  if (customElements.get('predictive-search')) {
    // Already defined; don’t re-register
    return;
  }
  const PredictiveSearchClass = class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');

      if (!this.input || !this.predictiveSearchResults) return;

      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
        return;
      }
      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      const q = encodeURIComponent(searchTerm);
      fetch(`/search/suggest?q=${q}&resources[limit_scope]=each&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            this.close();
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const wrapper = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          if (!wrapper) {
            this.close();
            return;
          }
          this.predictiveSearchResults.innerHTML = wrapper.innerHTML;
          this.open();
        })
        .catch((error) => {
          this.close();
          console.error('Predictive search error', error);
        });
    }

    open() {
      this.predictiveSearchResults.style.display = 'block';
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.input.setAttribute('aria-expanded', 'false');
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  };

  customElements.define('predictive-search', PredictiveSearchClass);
})();